<template>
  <div class="room gas-clamp">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>气夹</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">排气口</div>
          <div class="sensor2">进气口</div>
        </div>
        <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">镇宁(东)</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">胜境关(西)</span>
        </div>
        <div class="cable-img">
          <div class="clip sensor1 sensor-middle-left-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorMES1, humidityAllowedMaxMES1) }}
              </div>
              <div :class="errorMES1" class="state-info top-right-pos-1" @dblclick="hrefToScenario('')">
                <p>MES1传感器</p>
                <p>
                  <span>{{ humidityMES1 | toFixed }}% {{ temperatureMES1 | toFixed }}°C</span>
                  <br /><span>{{ pressureMES1 | toFixed }}%</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-left-3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorMESPlus, humidityAllowedMaxMESPlus) }}
              </div>
              <div :class="errorMESPlus" class="state-info bottom-pos" @dblclick="hrefToScenario('')">
                <p>MES+传感器</p>
                <p>
                  <span>{{ humidityMESPlus | toFixed }}% {{ temperatureMESPlus | toFixed }}°C</span>
                  <br /><span>{{ pressureMESPlus | toFixed }}% </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-up">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorMES0, humidityAllowedMaxMES0) }}
              </div>
              <div :class="errorMES0" class="state-info bottom-left-pos-mid" @dblclick="hrefToScenario('')">
                <p>MES0传感器</p>
                <p>
                  <span>{{ humidityMES0 | toFixed }}% {{ temperatureMES0 | toFixed }}°C</span>
                  <br /><span>{{ pressureMES0 | toFixed }}% </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-down">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorMWS0, humidityAllowedMaxMWS0) }}
              </div>
              <div :class="errorMWS0" class="state-info top-right-pos-mid" @dblclick="hrefToScenario('')">
                <p>MWS0传感器</p>
                <p>
                  <span>{{ humidityMWS0 | toFixed }}% {{ temperatureMWS0 | toFixed }}°C</span>
                  <br /><span>{{ pressureMWS0 | toFixed }}% </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-right-3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorMWSPlus, humidityAllowedMaxMWSPlus) }}
              </div>
              <div :class="errorMWSPlus" class="state-info bottom-pos" @dblclick="hrefToScenario('')">
                <p>MWS+传感器</p>
                <p>
                  <span>{{ humidityMWSPlus | toFixed }}% {{ temperatureMWSPlus | toFixed }}°C</span>
                  <br /><span>{{ pressureMWSPlus | toFixed }}% </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-right-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorMWS1, humidityAllowedMaxMWS1) }}
              </div>
              <div :class="errorMWS1" class="state-info top-left-pos-1" @dblclick="hrefToScenario('')">
                <p>MWS1传感器</p>
                <p>
                  <span>{{ humidityMWS1 | toFixed }}% {{ temperatureMWS1 | toFixed }}°C</span>
                  <br /><span>{{ pressureMWS1 | toFixed }}% </span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>主控箱</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">排气口</div>
          <div class="sensor2">进气口</div>
        </div>
        <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">镇宁(东)</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">胜境关(西)</span>
        </div>
        <div class="cable-img">
          <div class="clip sensor1 sensor-middle-left-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorMES1ControlBox, humidityAllowedMaxMES1ControlBox) }}
              </div>
              <div :class="errorMES1ControlBox" class="state-info top-right-pos-1" @dblclick="hrefToScenario('')">
                <p>MES1(主控箱)</p>
                <p>
                  <span>{{ humidityMES1ControlBox | toFixed }}% {{ temperatureMES1ControlBox | toFixed }}°C</span>
                  <br /><span>{{ pressureMES1ControlBox | toFixed }}%</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-left-3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorMESPlusControlBox, humidityAllowedMaxMESPlusControlBox) }}
              </div>
              <div :class="errorMESPlusControlBox" class="state-info bottom-pos" @dblclick="hrefToScenario('')">
                <p>MES+(主控箱)</p>
                <p>
                  <span>{{ humidityMESPlusControlBox | toFixed }}% {{ temperatureMESPlusControlBox | toFixed }}°C</span>
                  <br /><span>{{ pressureMESPlusControlBox | toFixed }}% </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-up">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorMES0ControlBox, humidityAllowedMaxMES0ControlBox) }}
              </div>
              <div :class="errorMES0ControlBox" class="state-info bottom-left-pos-mid" @dblclick="hrefToScenario('')">
                <p>MES0(主控箱)</p>
                <p>
                  <span>{{ humidityMES0ControlBox | toFixed }}% {{ temperatureMES0ControlBox | toFixed }}°C</span>
                  <br /><span>{{ pressureMES0ControlBox | toFixed }}% </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-down">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorMWS0ControlBox, humidityAllowedMaxMWS0ControlBox) }}
              </div>
              <div :class="errorMWS0ControlBox" class="state-info top-right-pos-mid" @dblclick="hrefToScenario('')">
                <p>MWS0(主控箱)</p>
                <p>
                  <span>{{ humidityMWS0ControlBox | toFixed }}% {{ temperatureMWS0ControlBox | toFixed }}°C</span>
                  <br /><span>{{ pressureMWS0ControlBox | toFixed }}% </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-right-3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorMWSPlusControlBox, humidityAllowedMaxMWSPlusControlBox) }}
              </div>
              <div :class="errorMWSPlusControlBox" class="state-info bottom-pos" @dblclick="hrefToScenario('')">
                <p>MWS+(主控箱)</p>
                <p>
                  <span>{{ humidityMWSPlusControlBox | toFixed }}% {{ temperatureMWSPlusControlBox | toFixed }}°C</span>
                  <br /><span>{{ pressureMWSPlusControlBox | toFixed }}% </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-right-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorMWS1ControlBox, humidityAllowedMaxMWS1ControlBox) }}
              </div>
              <div :class="errorMWS1ControlBox" class="state-info top-left-pos-1" @dblclick="hrefToScenario('')">
                <p>MWS1(主控箱)</p>
                <p>
                  <span>{{ humidityMWS1ControlBox | toFixed }}% {{ temperatureMWS1ControlBox | toFixed }}°C</span>
                  <br /><span>{{ pressureMWS1ControlBox | toFixed }}% </span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "gasClamp",
  data() {
    return {
      loading: true,
      timer: null,

      //humidity, temperature, pressure, flow, volume
      humidityMES1: "--",
      humidityMESPlus: "--",
      humidityMES0: "--",
      humidityMWS0: "--",
      humidityMWSPlus: "--",
      humidityMWS1: "--",
      humidityMES1ControlBox: "--",
      humidityMESPlusControlBox: "--",
      humidityMES0ControlBox: "--",
      humidityMWS0ControlBox: "--",
      humidityMWSPlusControlBox: "--",
      humidityMWS1ControlBox: "--",

      temperatureMES1: "--",
      temperatureMESPlus: "--",
      temperatureMES0: "--",
      temperatureMWS0: "--",
      temperatureMWSPlus: "--",
      temperatureMWS1: "--",
      temperatureMES1ControlBox: "--",
      temperatureMESPlusControlBox: "--",
      temperatureMES0ControlBox: "--",
      temperatureMWS0ControlBox: "--",
      temperatureMWSPlusControlBox: "--",
      temperatureMWS1ControlBox: "--",

      pressureMES1: "--",
      pressureMESPlus: "--",
      pressureMES0: "--",
      pressureMWS0: "--",
      pressureMWSPlus: "--",
      pressureMWS1: "--",
      pressureMES1ControlBox: "--",
      pressureMESPlusControlBox: "--",
      pressureMES0ControlBox: "--",
      pressureMWS0ControlBox: "--",
      pressureMWSPlusControlBox: "--",
      pressureMWS1ControlBox: "--",

      flowMES1ControlBox1: "--",
      flowMESPlusControlBox1: "--",
      flowMES0ControlBox1: "--",
      flowMWS0ControlBox1: "--",
      flowMWSPlusControlBox1: "--",
      flowMWS1ControlBox1: "--",
      flowMES1ControlBox2: "--",
      flowMESPlusControlBox2: "--",
      flowMES0ControlBox2: "--",
      flowMWS0ControlBox2: "--",
      flowMWSPlusControlBox2: "--",
      flowMWS1ControlBox2: "--",

      //running

      //malfunction

      //error
      errorMES1: "--",
      errorMESPlus: "--",
      errorMES0: "--",
      errorMWS0: "--",
      errorMWSPlus: "--",
      errorMWS1: "--",
      errorMES1ControlBox: "--",
      errorMESPlusControlBox: "--",
      errorMES0ControlBox: "--",
      errorMWS0ControlBox: "--",
      errorMWSPlusControlBox: "--",
      errorMWS1ControlBox: "--",

      //running class

      //humidity allowed max
      humidityAllowedMaxMES1: "--",
      humidityAllowedMaxMESPlus: "--",
      humidityAllowedMaxMES0: "--",
      humidityAllowedMaxMWS0: "--",
      humidityAllowedMaxMWSPlus: "--",
      humidityAllowedMaxMWS1: "--",
      humidityAllowedMaxMES1ControlBox: "--",
      humidityAllowedMaxMESPlusControlBox: "--",
      humidityAllowedMaxMES0ControlBox: "--",
      humidityAllowedMaxMWS0ControlBox: "--",
      humidityAllowedMaxMWSPlusControlBox: "--",
      humidityAllowedMaxMWS1ControlBox: "--",

      //humidity tooltip error
      humidityTooltipErrorMES1: "--",
      humidityTooltipErrorMESPlus: "--",
      humidityTooltipErrorMES0: "--",
      humidityTooltipErrorMWS0: "--",
      humidityTooltipErrorMWSPlus: "--",
      humidityTooltipErrorMWS1: "--",
      humidityTooltipErrorMES1ControlBox: "--",
      humidityTooltipErrorMESPlusControlBox: "--",
      humidityTooltipErrorMES0ControlBox: "--",
      humidityTooltipErrorMWS0ControlBox: "--",
      humidityTooltipErrorMWSPlusControlBox: "--",
      humidityTooltipErrorMWS1ControlBox: "--",

      dataNameIdDict: {
        //humidity, temperature
        humidityMES1: "06bf02a9-2ffd-477d-a7c1-21578316c945",
        humidityMESPlus: "0210b071-ecf5-44cf-9d5b-fb7c73c2b074",
        humidityMES0: "2667db2e-80b0-4225-ad59-b1d4446315c2",
        humidityMWS0: "2b9e5afc-d802-41d0-a91c-1dff73d8c899",
        humidityMWSPlus: "ac882b53-6627-4d4a-ad48-e64cbade15d3",
        humidityMWS1: "15b27b59-4e98-4232-aef5-ce13454ad0fa",
        humidityMES1ControlBox: "b467e3f8-3b75-4a3c-9518-1f28256901d9",
        humidityMESPlusControlBox: "78112eb0-1edd-463a-bbde-b6944e5214e6",
        humidityMES0ControlBox: "77ca89fa-2eae-4b6b-9fb0-02e398eee2e4",
        humidityMWS0ControlBox: "a05afa75-46a2-4ca4-8fba-285271270240",
        humidityMWSPlusControlBox: "8191d80c-3d1b-499f-bc85-c891457890ad",
        humidityMWS1ControlBox: "22ceae81-e086-4789-943a-3dccf0af872c",

        temperatureMES1: "0ec15932-6c9b-4757-ba91-b6104213c30a",
        temperatureMESPlus: "80dee89e-3ba7-4aca-aebd-3fc3d6c6652b",
        temperatureMES0: "1ffdc390-305d-425b-8a45-7e11b76306cc",
        temperatureMWS0: "08c61bf8-c0c6-4902-b9ee-e95c737d154c",
        temperatureMWSPlus: "2d512b46-1bce-4a57-86c9-4bbc8a16ec8f",
        temperatureMWS1: "ac135491-0977-41ef-8eac-7a14b486d769",
        temperatureMES1ControlBox: "bdadd660-728f-4f81-bd0b-2d1cd6268d43",
        temperatureMESPlusControlBox: "fc0aa3f8-54c7-4f11-89fe-155b8d3fe2e0",
        temperatureMES0ControlBox: "e5ef239d-472b-4832-9344-9f4bc9a14579",
        temperatureMWS0ControlBox: "f9a7cfaa-66ab-42a6-9dfd-3d7938c8d11a",
        temperatureMWSPlusControlBox: "8f3b375d-0bb1-4c6e-befe-02c8ab82a550",
        temperatureMWS1ControlBox: "939c77f5-014e-4343-94c5-6cc408491d70",

        pressureMES1: "6daa40f9-3613-4def-9609-8525471b8539",
        pressureMESPlus: "cd58d0a4-b7c1-4ce4-8ce9-811bfd6e8894",
        pressureMES0: "44417e6c-975b-4f56-81a7-0abf823c384c",
        pressureMWS0: "10ae4c00-2ca8-450e-8da8-0d80ef43c9ba",
        pressureMWSPlus: "0aede726-076f-4690-9d4f-621d05d21c4b",
        pressureMWS1: "1505d8c6-6925-4534-9409-7dbc91ffe612",
        pressureMES1ControlBox: "ee14180d-43b5-41ce-afe2-be2b4192c939",
        pressureMESPlusControlBox: "3bce3dee-2a5e-4b83-93a8-a34a5c1f3fb7",
        pressureMES0ControlBox: "863092a8-b1f6-423c-a1d8-e14e7622cac6",
        pressureMWS0ControlBox: "765c48d9-a85c-49d8-866a-3a61e7bb82c8",
        pressureMWSPlusControlBox: "807e2e9e-7674-492a-8d3e-811b525e1601",
        pressureMWS1ControlBox: "1952e7b5-2ab9-4c22-bfc2-5e470f1ae6d8",

        flowMES1ControlBox1: "20551fef-7ac5-411b-b499-6147bb6f4f5c",
        flowMESPlusControlBox1: "995d3469-8364-4e3e-978b-f196ac59dce6",
        flowMES0ControlBox1: "9603e463-31ad-4d0f-9ae0-0f654937de09",
        flowMWS0ControlBox1: "119990b4-8a11-40ae-939b-7a5f74771a09",
        flowMWSPlusControlBox1: "f4e0bcdc-1987-4f46-a1c9-b60ef939e95a",
        flowMWS1ControlBox1: "5dd76bc1-3e80-42a6-80d5-d09244977e52",

        flowMES1ControlBox2: "049dcbd8-f8c1-482d-ade0-0ab8bb418b18",
        flowMESPlusControlBox2: "106dff4a-4236-4df0-b1bd-ccd7c6653ae3",
        flowMES0ControlBox2: "00765399-d773-461c-b4ab-ea408a69d830",
        flowMWS0ControlBox2: "e63af158-5096-41d7-8c27-68ce4151b423",
        flowMWSPlusControlBox2: "cefdf7f6-24bc-4035-a3bc-582b8872a0f5",
        flowMWS1ControlBox2: "6b97dffb-376b-498d-8b8d-ff42a0dfaebc",

        //running

        //malfunction
      },

      //humidity allowed max -> id
      allowedMaxNameIdDict: {
        humidityAllowedMaxMES1: "06bf02a9-2ffd-477d-a7c1-21578316c945",
        humidityAllowedMaxMESPlus: "0210b071-ecf5-44cf-9d5b-fb7c73c2b074",
        humidityAllowedMaxMES0: "2667db2e-80b0-4225-ad59-b1d4446315c2",
        humidityAllowedMaxMWS0: "2b9e5afc-d802-41d0-a91c-1dff73d8c899",
        humidityAllowedMaxMWSPlus: "ac882b53-6627-4d4a-ad48-e64cbade15d3",
        humidityAllowedMaxMWS1: "15b27b59-4e98-4232-aef5-ce13454ad0fa",
        humidityAllowedMaxMES1ControlBox: "b467e3f8-3b75-4a3c-9518-1f28256901d9",
        humidityAllowedMaxMESPlusControlBox: "78112eb0-1edd-463a-bbde-b6944e5214e6",
        humidityAllowedMaxMES0ControlBox: "77ca89fa-2eae-4b6b-9fb0-02e398eee2e4",
        humidityAllowedMaxMWS0ControlBox: "a05afa75-46a2-4ca4-8fba-285271270240",
        humidityAllowedMaxMWSPlusControlBox: "8191d80c-3d1b-499f-bc85-c891457890ad",
        humidityAllowedMaxMWS1ControlBox: "22ceae81-e086-4789-943a-3dccf0af872c",
      },

      //humidity, temperature -> error
      dataNameErrorNameDict: {
        humidityMES1: "errorMES1",
        humidityMESPlus: "errorMESPlus",
        humidityMES0: "errorMES0",
        humidityMWS0: "errorMWS0",
        humidityMWSPlus: "errorMWSPlus",
        humidityMWS1: "errorMWS1",
        humidityMES1ControlBox: "errorMES1ControlBox",
        humidityMESPlusControlBox: "errorMESPlusControlBox",
        humidityMES0ControlBox: "errorMES0ControlBox",
        humidityMWS0ControlBox: "errorMWS0ControlBox",
        humidityMWSPlusControlBox: "errorMWSPlusControlBox",
        humidityMWS1ControlBox: "errorMWS1ControlBox",

        temperatureMES1: "errorMES1",
        temperatureMESPlus: "errorMESPlus",
        temperatureMES0: "errorMES0",
        temperatureMWS0: "errorMWS0",
        temperatureMWSPlus: "errorMWSPlus",
        temperatureMWS1: "errorMWS1",
        temperatureMES1ControlBox: "errorMES1ControlBox",
        temperatureMESPlusControlBox: "errorMESPlusControlBox",
        temperatureMES0ControlBox: "errorMES0ControlBox",
        temperatureMWS0ControlBox: "errorMWS0ControlBox",
        temperatureMWSPlusControlBox: "errorMWSPlusControlBox",
        temperatureMWS1ControlBox: "errorMWS1ControlBox",

        pressureMES1: "errorMES1",
        pressureMESPlus: "errorMESPlus",
        pressureMES0: "errorMES0",
        pressureMWS0: "errorMWS0",
        pressureMWSPlus: "errorMWSPlus",
        pressureMWS1: "errorMWS1",
        pressureMES1ControlBox: "errorMES1ControlBox",
        pressureMESPlusControlBox: "errorMESPlusControlBox",
        pressureMES0ControlBox: "errorMES0ControlBox",
        pressureMWS0ControlBox: "errorMWS0ControlBox",
        pressureMWSPlusControlBox: "errorMWSPlusControlBox",
        pressureMWS1ControlBox: "errorMWS1ControlBox",

        flowMES1ControlBox1: "errorMES1ControlBox1",
        flowMESPlusControlBox1: "errorMESPlusControlBox1",
        flowMES0ControlBox1: "errorMES0ControlBox1",
        flowMWS0ControlBox1: "errorMWS0ControlBox1",
        flowMWSPlusControlBox1: "errorMWSPlusControlBox1",
        flowMWS1ControlBox1: "errorMWS1ControlBox1",
        flowMES1ControlBox2: "errorMES1ControlBox2",
        flowMESPlusControlBox2: "errorMESPlusControlBox2",
        flowMES0ControlBox2: "errorMES0ControlBox2",
        flowMWS0ControlBox2: "errorMWS0ControlBox2",
        flowMWSPlusControlBox2: "errorMWSPlusControlBox2",
        flowMWS1ControlBox2: "errorMWS1ControlBox2",
      },

      //malfunction -> error
      malfunctionDataNameErrorNameDict: {},

      //humidity -> humidity tooltip error
      dataNameTooltipErrorNameDict: {
        humidityMES1: "humidityAllowedMaxMES1",
        humidityMESPlus: "humidityAllowedMaxMESPlus",
        humidityMES0: "humidityAllowedMaxMES0",
        humidityMWS0: "humidityAllowedMaxMWS0",
        humidityMWSPlus: "humidityAllowedMaxMWSPlus",
        humidityMWS1: "humidityAllowedMaxMWS1",
        humidityMES1ControlBox: "humidityAllowedMaxMES1ControlBox",
        humidityMESPlusControlBox: "humidityAllowedMaxMESPlusControlBox",
        humidityMES0ControlBox: "humidityAllowedMaxMES0ControlBox",
        humidityMWS0ControlBox: "humidityAllowedMaxMWS0ControlBox",
        humidityMWSPlusControlBox: "humidityAllowedMaxMWSPlusControlBox",
        humidityMWS1ControlBox: "humidityAllowedMaxMWS1ControlBox",
      },

      //running -> running class
      dataNameRunningClassNameDict: {},

      //station id list
      stationIdList: ["c5f293d6-6bdb-4c98-b187-d21574908a9e", "4995c5ef-a1fa-41ef-9d74-83bf3d2f75cc"],
    };
  },
  filters: {
    toFixed(val) {
      if (val === 0) return "0.0";
      if (!Number(val)) return "--";
      return Number(val).toFixed(1);
    },
  },
  mounted() {
    this.getAllowedMax();
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.getData();
    },
    getData() {
      this.resetError();
      let stationRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationRequestList.push(this.$http.get(`/deviceData/Station?stationId=${stationId}`));
      });

      this.$http.all(stationRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setDataAndError(res.data);
            this.loading = false;
          });
        })
      );
    },
    setDataAndError(stationData) {
      //device id not set (device id = 'GUID') = no data
      stationData["GUID"] = {
        dataId: null,
        deviceId: "GUID",
        value: null,
        createdDate: "0001-01-01T00:00:00",
        dataDate: "0001-01-01T00:00:00",
        dataType: "VALUE",
        errorLevel: "Warning",
      };

      for (let dataName in this.dataNameIdDict) {
        const dataId = this.dataNameIdDict[dataName];
        if (stationData[dataId] !== undefined) {
          this[dataName] = stationData[dataId].value;

          // //set value for running sign
          // if (this.dataNameRunningTooltipNameDict[dataName] !== undefined && this.dataNameRunningClassNameDict[dataName] != undefined) {
          //   let runningData = stationData[dataId];
          //   if (runningData.value === 1) {
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "运行";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "running";
          //   } else if (runningData.errorLevel !== "Warning") {
          //     //empty data value also === 0
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "停止";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
          //   }
          // }

          //set value for running sign
          if (this.dataNameRunningClassNameDict[dataName] != undefined) {
            let runningData = stationData[dataId];
            if (runningData.value === 1) {
              this[this.dataNameRunningClassNameDict[dataName]] = "running";
            } else if (runningData.errorLevel !== "Warning") {
              //empty data value also === 0
              this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
            }
          }

          if (this.dataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameErrorNameDict[dataName];
            this[errorName] = this.getErrorLevelFromMultipleDevice(this[errorName], stationData[dataId].errorLevel);
          }

          if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameTooltipErrorNameDict[dataName];
            this[errorName] = stationData[dataId].errorLevel;
          }

          if (this.malfunctionDataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.malfunctionDataNameErrorNameDict[dataName];
            if (this[errorName] === "" && stationData[dataId].value && stationData[dataId].value > 0) {
              this[errorName] = "Error";
            }
          }
        }
      }
    },
    getAllowedMax() {
      let stationMetaRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationMetaRequestList.push(this.$http.get(`/bridge/StationInfo?stationId=${stationId}`));
      });

      this.$http.all(stationMetaRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setAllowedMax(res.data);
          });
        })
      );
    },
    setAllowedMax(stationData) {
      let deviceIdDevicedict = {};
      if (stationData.deviceList) {
        stationData.deviceList.forEach((item) => {
          deviceIdDevicedict[item.deviceId] = item;
        });
      }

      for (let allowedMaxName in this.allowedMaxNameIdDict) {
        const dataId = this.allowedMaxNameIdDict[allowedMaxName];
        if (deviceIdDevicedict[dataId] !== undefined) {
          let device = deviceIdDevicedict[dataId];
          this[allowedMaxName] = device.allowedMax;
        }
      }
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
    resetError() {
      for (let dataName in this.dataNameIdDict) {
        if (this.dataNameErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameErrorNameDict[dataName];
          this[errorName] = "";
        }

        if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameTooltipErrorNameDict[dataName];
          this[errorName] = "";
        }
      }
    },
    assembleTooltip_sensor(name, errorLevel, allowedMax) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if (
        (errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") &&
        allowedMax !== undefined &&
        allowedMax !== null &&
        !isNaN(parseInt(allowedMax))
      ) {
        if (allowedMax === 0) {
          result += "(无限制)";
        } else {
          result += "(<" + allowedMax + "%RH)";
        }
      }

      return result;
    },
    assembleTooltip_dehumidifier(name, errorLevel, allowedMax, runningFlag, errorFlag) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      if (errorLevel === "" && allowedMax === "") {
        //no humidity dehumidifier
        // console.log('running flag: ' + runningFlag + ", error flag: " + errorFlag);
        if (runningFlag === null || errorFlag === null) {
          result += "数据中断";
        }

        if (runningFlag > 0) {
          result += " 除湿机运行";
        } else if (runningFlag === 0) {
          result += " 除湿机停止";
        }

        if (errorFlag > 0) {
          result += "  故障报警";
        }
      } else {
        //normal dehumidifier
        if (errorLevel.toLowerCase() !== "warning") {
          if (runningFlag > 0) {
            result += ", 除湿机运行";
          } else if (runningFlag === 0) {
            result += ", 除湿机停止";
          }
        }

        if (errorFlag > 0) {
          result += ", 故障报警";
        }
      }

      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes breathee-warning {
  0% {
    border-color: rgba(255, 255, 0, 0.3);
  }

  100% {
    border-color: #ffff00;
    // background: rgba(255, 255, 255, 0.7);
  }
}

@keyframes breathee-error {
  0% {
    border-color: rgba(255, 0, 0, 0.3);
  }

  100% {
    border-color: #ff0000;
    // background: rgba(255, 255, 255, 0.7);
  }
}

.tooltip-slot {
  line-height: 1.4;
}

.gas-clamp {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 20px) !important;
  // min-height: 630px !important;

  .main-cable {
    width: 100%;
    height: 48%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    min-height: 370px;

    .cable-title {
      width: 50px;
      text-align: center;
      display: flex;
      background-color: #fff;
      justify-content: center;
      align-items: center;

      h2 {
        padding: 0 10px;
        font-weight: bold;
        font-size: 32px;
        line-height: 35px;
        color: #515151;
      }
    }

    .cable-main {
      position: relative;
      min-width: 1350px;
      width: calc(100% - 50px);
      background: linear-gradient(#ceeaf0, #e9f1ef);
      display: flex;
      justify-content: center;
      align-items: center;

      .legend {
        position: absolute;
        left: 75px;
        top: 50px;

        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;

          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }

        .sensor1:after {
          background: #c7798b;
        }

        .sensor2:after {
          background: #3376c7;
        }
      }

      .legend-right {
        position: absolute;
        right: 70px;
        top: 50px;

        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;

          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }

        .default:after {
          background: #ffff00;
        }

        .running:after {
          background: #67dd34;
        }

        .stopped:after {
          background: #a0a0a0;
        }
      }

      .legend-station {
        position: absolute;
        left: 73px;
        top: 108px;

        i {
          font-size: 24px;
          color: #ed6a5a;
        }

        span {
          padding-left: 8px;
          bottom: 3px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
        }
      }

      .dir {
        position: absolute;
        top: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #2a387a;

        i {
          font-size: 30px;
        }

        .dir-text {
          font-size: 20px;
        }
      }

      .left-dir {
        left: 185px;
      }

      .right-dir {
        flex-direction: row-reverse;
        right: 185px;
      }

      .cable-img {
        position: relative;
        z-index: 0;
        width: 1200px;
        height: 300px;
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url("../../assets/image/beipanjiang/bridgeLine.png");
        background-position-y: 100%;

        .station-block {
          position: absolute;
          color: #ed6a5a;
          font-size: 24px;
          text-decoration: none;
        }

        .stati {
          position: absolute;

          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
            background: #ed6a5a;
          }

          &:before {
            width: 50px;
          }

          &:after {
            width: 15px;
          }

          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            text-decoration: none;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            background-color: rgba(246, 250, 255, 0.9);

            &:before {
              background-color: #ed6a5a;
            }

            & > p {
              margin: 0;
              white-space: nowrap;
              white-space: nowrap;
              display: flex;
              justify-content: space-between;
              align-items: baseline;

              &:first-child {
                font-size: 13px;
              }
            }

            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }

            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }

            &.bottom-pos:before {
              left: 50%;
              top: 95%;
              transform: translate(0%, 0%);
            }

            &.top-pos:before {
              left: 50%;
              top: -3px;
              transform: translate(0%, 0%);
            }

            &.bottom-pos-sta:before {
              left: 50%;
              top: 95%;
              transform: translate(0%, 0%);
            }

            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }

            .bold {
              font-weight: 800;
            }

            .valve-sign {
              margin-top: auto;
              margin-bottom: auto;
              width: 12px;
              height: 12px;
              background-color: #ffff00;
              animation: breathee-valve-sign-default 1500ms infinite alternate ease-in-out;
              border-radius: 10px;
              margin-left: 15px;

              &.running {
                background-color: #67dd34;
                animation: none;
              }

              &.stopped {
                background-color: #a0a0a0;
                animation: none;
              }
            }
          }

          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }

          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
        }

        .clip {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;

          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
          }

          &:before {
            width: 50px;
          }

          &:after {
            width: 15px;
          }

          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);

            & > p {
              margin: 0;
              white-space: nowrap;

              &:first-child {
                font-size: 13px;
              }
            }

            .bold {
              font-weight: 800;
            }

            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }

            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }

            &.bottom-pos:before {
              left: 50%;
              top: 95%;
              transform: translate(0%, 0%);
            }

            &.bottom-left-pos-mid:before {
              left: 47.5%;
              top: 95%;
              transform: translate(0%, 0%);
            }

            &.top-pos:before {
              left: 46%;
              top: -5%;
              transform: translate(0%, 0%);
            }

            &.top-left-pos-1:before {
              left: 20%;
              top: -5%;
              transform: translate(0%, 0%);
            }

            &.top-right-pos-1:before {
              left: 80%;
              top: -5%;
              transform: translate(0%, 0%);
            }

            &.top-right-pos-mid:before {
              left: 52.5%;
              top: -5%;
              transform: translate(0%, 0%);
            }

            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }

          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }

          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }

          &.sensor1 {
            background: #c7798b;

            &:after,
            &:before {
              background: #c7798b;
            }

            .state-info {
              background-color: rgba(246, 250, 255, 0.9);

              &:before {
                background-color: #c7798b;
              }
            }
          }

          &.sensor2 {
            background: #3376c7;

            &:after,
            &:before {
              background: #3376c7;
            }

            .state-info {
              background-color: rgba(246, 250, 255, 0.9);

              &:before {
                background-color: #3376c7;
              }
            }
          }
        }

        .station-block-left {
          top: 95px;
          left: 230px;
        }

        .station-block-middle {
          top: 165px;
          left: 590px;
        }

        .station-block-right {
          top: 93px;
          left: 953px;
        }

        .sta-left {
          top: 108px;
          left: 282px;

          &::before {
            bottom: 20px;
            left: -65px;
            width: 50px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }

          .state-info {
            right: -35px;
            top: -65px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-middle {
          top: 188px;
          left: 640px;

          &::before {
            bottom: 75px;
            left: -105px;
            width: 130px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }

          .state-info {
            right: -29px;
            top: -150px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-right {
          top: 108px;
          left: 1005px;

          &::before {
            bottom: 25px;
            left: -60px;
            width: 40px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }

          .state-info {
            right: -42px;
            top: -65px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sensor-left-1 {
          top: 161px;
          left: 110px;

          &::before {
            bottom: 22px;
            left: -16px;
            width: 40px;
            transform: rotate(75deg);
          }

          &::after {
            bottom: 41px;
            left: -16px;
          }

          .state-info {
            right: 28px;
            top: -26px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sensor-left-2 {
          top: 130px;
          left: 190px;

          &::before {
            bottom: -27px;
            left: -30px;
            width: 75px;
            transform: rotate(270deg);
          }

          &::after {
            bottom: -54px;
            left: 14px;
            width: 0px;
          }

          .state-info {
            right: -15px;
            top: 112px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sensor-left-3 {
          top: 100px;
          left: 272px;

          &::before {
            bottom: 22px;
            left: -20px;
            width: 40px;
            transform: rotate(60deg);
          }

          &::after {
            bottom: 39px;
            left: -24px;
          }

          .state-info {
            right: 35px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sensor-middle-left-1-no-plus {
          top: 100px;
          left: 293px;

          &::before {
            bottom: 22px;
            left: -4px;
            width: 40px;
            transform: rotate(120deg);
          }

          &::after {
            bottom: 39px;
            left: 25px;
          }

          .state-info {
            right: -155px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sensor-middle-left-1 {
          top: 100px;
          left: 293px;

          &::before {
            bottom: 44px;
            left: -21px;
            width: 80px;
            transform: rotate(105deg);
          }

          &::after {
            bottom: 82px;
            left: 29px;
          }

          .state-info {
            right: -155px;
            top: -66px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sensor-middle-left-2 {
          top: 140px;
          left: 444px;

          &::before {
            bottom: -27px;
            left: -25px;
            width: 65px;
            transform: rotate(270deg);
          }

          &::after {
            bottom: -54px;
            left: 14px;
            width: 0px;
          }

          .state-info {
            right: -15px;
            top: 102px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sensor-middle-left-3 {
          top: 150px;
          left: 518px;

          &::before {
            bottom: 15px;
            left: -5px;
            width: 25px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }

          .state-info {
            right: -50px;
            top: -45px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 125px;
          }
        }

        .sensor-middle-up-no-plus {
          top: 150px;
          left: 580px;

          &::before {
            bottom: 30px;
            left: -20px;
            width: 55px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }

          .state-info {
            right: -56px;
            top: -74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sensor-middle-up {
          top: 150px;
          left: 580px;

          &::before {
            bottom: 52px;
            left: -42px;
            width: 100px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }

          .state-info {
            right: -56px;
            top: -120px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sensor-middle-down {
          top: 150px;
          left: 590px;

          &::before {
            bottom: -20px;
            left: -15px;
            width: 45px;
            transform: rotate(270deg);
          }

          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }

          .state-info {
            right: -49px;
            top: 92px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sensor-middle-right-3 {
          top: 150px;
          left: 652px;

          &::before {
            bottom: 15px;
            left: -5px;
            width: 25px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }

          .state-info {
            right: -50px;
            top: -45px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 125px;
          }
        }

        .sensor-middle-right-2 {
          top: 140px;
          left: 726px;

          &::before {
            bottom: -27px;
            left: -25px;
            width: 65px;
            transform: rotate(270deg);
          }

          &::after {
            bottom: -54px;
            left: 14px;
            width: 0px;
          }

          .state-info {
            right: -90px;
            top: 102px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sensor-middle-right-1-no-plus {
          top: 100px;
          left: 880px;

          &::before {
            bottom: 22px;
            left: -20px;
            width: 40px;
            transform: rotate(60deg);
          }

          &::after {
            bottom: 39px;
            left: -24px;
          }

          .state-info {
            right: 40px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sensor-middle-right-1 {
          top: 100px;
          left: 880px;

          &::before {
            bottom: 44px;
            left: -42px;
            width: 80px;
            transform: rotate(75deg);
          }

          &::after {
            bottom: 82px;
            left: -27px;
          }

          .state-info {
            right: 40px;
            top: -66px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sensor-right-3 {
          top: 100px;
          left: 898px;

          &::before {
            bottom: 22px;
            left: -5px;
            width: 40px;
            transform: rotate(120deg);
          }

          &::after {
            bottom: 39px;
            left: 24px;
          }

          .state-info {
            right: -148px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sensor-right-2 {
          top: 130px;
          left: 980px;

          &::before {
            bottom: -27px;
            left: -30px;
            width: 75px;
            transform: rotate(270deg);
          }

          &::after {
            bottom: -54px;
            left: 14px;
            width: 0px;
          }

          .state-info {
            right: -91px;
            top: 112px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sensor-right-1 {
          top: 161px;
          left: 1060px;

          &::before {
            bottom: 22px;
            left: -8px;
            width: 40px;
            transform: rotate(105deg);
          }

          &::after {
            bottom: 41px;
            left: 16px;
          }

          .state-info {
            right: -142px;
            top: -26px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }
      }
    }
  }
}
</style>
